<template>
  <div id="vanber">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>岗位管理</el-breadcrumb-item>
        <el-breadcrumb-item>简历管理</el-breadcrumb-item>
      </el-breadcrumb>
      <hr>
    </el-row>
    <el-row>
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="申请时间">
          <el-date-picker v-model="formInline.time"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学校">
          <el-select v-model="formInline.type"
                     filterable
                     placeholder="请选择">
            <el-option label="万博"
                       value="1">
            </el-option>
            <el-option label="虹桥大学"
                       value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请岗位">
          <el-select v-model="formInline.type"
                     filterable
                     placeholder="请选择">
            <el-option label="岗位一"
                       value="1">
            </el-option>
            <el-option label="岗位二"
                       value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校名称">
          <el-input v-model="formInline.name"
                    placeholder="请输入学校名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table :data="tableData"
                border
                style="width: 100%"
                id="table">
        <el-table-column prop="job_name"
                         label="姓名"
                         width="120">
        </el-table-column>
        <el-table-column fixed
                         prop="created_at"
                         label="申请时间"
                         width="140"
                         sortable>
        </el-table-column>
        <el-table-column prop="contact"
                         label="联系电话"
                         width="150">
        </el-table-column>
        <el-table-column prop="telephone"
                         label="学校"
                         width="120">
        </el-table-column>
        <el-table-column prop="recruitment"
                         label="合作专业方向"
                         width="120">
        </el-table-column>
        <el-table-column prop="salary_str"
                         label="实习经历"
                         width="200">
        </el-table-column>
        <el-table-column prop="expect_start"
                         label="申请岗位">
        </el-table-column>
        <!-- <el-table-column label="操作"
                         fixed="right"
                         width="180">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="primary"
                       @click="read(scope.row)">查看</el-button>
          </template>
          <el-dialog :visible.sync="dialogVisible"
                     width="30%"
                     :append-to-body="true">
            <el-row v-for="item in dialog"
                    :key="item.key">
              <el-col :span="12">
                <div class="text-right">{{ item.name }}</div>
              </el-col>
              <el-col :span="
                    12">
                <div>{{ item.value }}</div>
              </el-col>
            </el-row>
          </el-dialog>
        </el-table-column> -->
      </el-table>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="block">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pickerOptions1: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      formInline: {
        time: "",
        e_name: ""
      },
      // 分页
      total: 0, // 总数
      page: 1, // 当前页
      page_size: 10, // 每页条数
      tableData: [],
      //弹出框
      dialogVisible: false,
      dialog: [
        {
          name: '发布时间：',
          key: 'created_at',
          value: ''
        },
        {
          name: '岗位：',
          key: 'job_name',
          value: ''
        },
        {
          name: '联系人：',
          key: 'contact',
          value: ''
        },
        {
          name: '电话：',
          key: 'telephone',
          value: ''
        },
        {
          name: 'email：',
          key: 'email',
          value: ''
        },
        {
          name: '详细地址：',
          key: 'job_address',
          value: ''
        },
        {
          name: '岗位描述：',
          key: 'job_detail',
          value: ''
        },
        {
          name: '岗位吸引力：',
          key: 'job_attraction',
          value: ''
        },
        {
          name: '岗位要求：',
          key: 'request',
          value: ''
        },
        {
          name: '招聘人数：',
          key: 'recruitment',
          value: ''
        },
        {
          name: '岗位待遇：',
          key: 'salary_str',
          value: ''
        },
        {
          name: '到岗时间：',
          key: 'expect_start',
          value: ''
        },
        {
          name: '过期时间：',
          key: 'expect_end',
          value: ''
        },
        {
          name: '食宿安排：',
          key: 'food_bed_str',
          value: ''
        },
        {
          name: '对口专业：',
          key: 'expect_major',
          value: ''
        },
        {
          name: '截止时间：',
          key: 'end_time',
          value: ''
        },
        {
          name: '备注：',
          key: 'remark',
          value: ''
        },
      ]
    }
  },
  mounted () {
    // this.getList()
  },
  methods: {
    //获取列表
    async getList (params = {
      page: this.page,
      page_size: this.page_size,
      start: this.formInline.time[0],
      end: this.formInline.time[1],
      e_name: this.formInline.e_name,
    }) {
      let res = await this.$api.job.getJobList(params);
      if (res.code === 0) {
        if (res.data.item !== []) {
          this.tableData = res.data.items;
          this.total = res.data.count;
        }
      }
    },
    // 查看岗位详情
    read (row) {
      this.dialogVisible = true
      let dialog = this.dialog;
      for (let item of dialog) {
        item.value = row[item.key]
      }
    },
    //查询
    onSubmit () {
      this.getList()
    },
    // 发布岗位
    add () {
      this.$router.push("/jobAdd")
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.page = val
    },
  }
}
</script>

<style scoped lang="scss">
  #vanber {
    padding: 20px;
  }
</style>
